// Base
import Image from 'next/image'
import { useState } from 'react'
import Link from 'next/link'

// Components
import { Box, Button, Container, Flex } from 'yard-utilities/components'
import Menu from './menu/Menu'
import Navigation from './navigation/Navigation'
import CountdownBanner from './countdown-banner/CountdownBanner'

// Styles
import styles from './Header.module.sass'

interface HeaderProps {
  displayCounter?: boolean
  discount?: number
  signUpLink?: string
  sectionLink?: string
}

const Header = ({
  displayCounter = false,
  discount,
  signUpLink = '/v25/es/membership',
  sectionLink
}: HeaderProps) => {
  const [displayNavigation, setDisplayNavigation] = useState(false)

  return (
    <header className={styles.header}>
      <Container>
        <Box paddingY={{ sm: 16 }}>
          <Flex alignItems="center" justifyContent="space-between">
            <Image
              src="/images/v25/logos/ratepunk-logo.svg"
              width={128}
              height={32}
              alt="RatePunk logo"
            />

            <Flex alignItems="center" columnGap={{ sm: 16 }}>
              <Button
                as={Link}
                href={signUpLink}
                variant="yellow-xs"
                transform="uppercase"
                buttonWidth={128}
              >
                Registrarse
              </Button>

              <Menu
                active={displayNavigation}
                toggleMenu={() => {
                  setDisplayNavigation((prevState) => !prevState)
                }}
              />
            </Flex>
          </Flex>
        </Box>
      </Container>

      {displayCounter && <CountdownBanner discount={discount} />}

      <Navigation
        active={displayNavigation}
        closeMenu={() => {
          setDisplayNavigation(false)
        }}
        sectionLink={sectionLink}
        signUpLink={signUpLink}
      />
    </header>
  )
}

export default Header
